"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlayGame = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var usePlayGame = function (currentGame) {
    var _a;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var signUpUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL);
    var router = (0, navigation_1.useRouter)();
    var slug = (_a = currentGame === null || currentGame === void 0 ? void 0 : currentGame.slug) === null || _a === void 0 ? void 0 : _a.replace(/\'/g, '');
    return (0, react_1.useCallback)(function () {
        router.push(isAuth ? generateUrlWithLang("/game/".concat(slug)) : signUpUrl);
    }, [isAuth, generateUrlWithLang, router, signUpUrl, currentGame]);
};
exports.usePlayGame = usePlayGame;
